import axios from 'axios'
const serviceConfig = require('../../config/service.json')

const noAuthClient = axios.create({
    baseURL: serviceConfig.authServiceURL,
})

export default noAuthClient
